import React, { useEffect, useRef, useState } from 'react'
import { Container, Row, Col, Form, Button, Card, FormSelect,  } from 'react-bootstrap'
import Select from "react-select"
import { useTranslation } from "react-i18next"
import useAuth from '../../context/auth/useAuth'
import { useDispatch, useSelector } from 'react-redux'
import { getCandidate, addCandidateTitle, deleteCandidateTitle, changeSpecificFormation, getCandidateProfileStatus, deleteCandidateTeacherFormationMaster, getTitles} from '../../actions/candidatesActions'
import Swal from 'sweetalert2'
import { FileNameExtractor } from '../../components/filenameextractor'
import SubMenuTitles from '../../components/menus/SubMenuTitles'
import { useParams } from 'react-router-dom'

export default function OfficialTitles() {
    const {id: candidateId} = useParams() || {}
    const { t } = useTranslation()
	const {client} = useAuth()
    const dispatch = useDispatch()

    const titleFileInput = useRef(null)
    const postTitleFileInput = useRef(null)
    const teacherFormationMasterCertificateInput = useRef(null)
    const ibTeacherCertificateInput = useRef(null)

    const {candidate, resultcandidate, titles} = useSelector(state=>state.candidates)

    const [titleFile, setTitleFile] = useState(null)
    const [postTitleFile, setPostTitleFile] = useState(null)

    const [specificFormationForm, setSpecificFormationForm] = useState({
        teacherFormationMaster: false,
        teacherFormationMasterCertificateUrl: null,
        ibTeacher: false,
        ibTeacherCertificateUrl: null,
        deca: false
    })

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'instant',
        })
        if(client){
            dispatch(getCandidate(candidateId || client?.id))
            dispatch(getTitles())
        }
    },[dispatch, t, client])

    useEffect(() => {
        const sortedOptions = titles.map((title) => ({
            label: t('titles.' + title.title),
            value: title.id
        })).sort((a, b) => a.label.localeCompare(b.label))
        setNewAcademicTitle({
            ...newAcademicTitle,
            options: sortedOptions
        })
    // eslint-disable-next-line
    }, [titles])

    const [newAcademicTitle, setNewAcademicTitle] = useState({
        options: 
            titles.map((title) => (
                {label: t('titles.'+title.title), value: title.id}
            )),
        selected: null
    })

    const [formStateNewAcademic, setFormStateNewAcademic] = useState({
		studyCentre: '',
		end_date: '',
        certificationUrl: null,
    })

    const [formStateNewAcademicPostTitle, setFormStateNewAcademicPostTitle] = useState({
        type: 'postgraduate',
        title: '',
		studyCentre: '',
		end_date: '',
        certificationUrl: null,
    })


    const handleInputNewAcademic = ({target})=>{
        setFormStateNewAcademic({
            ...formStateNewAcademic,
            [target.name]: target.value
        })
    }

    const handleInputNewAcademicPostTitle = ({target}) => {
        setFormStateNewAcademicPostTitle({
            ...formStateNewAcademicPostTitle,
            [target.name]: target.value
        })
    }

    const handleSelectNewAcademic = (target) => {
        setNewAcademicTitle({
            ...newAcademicTitle,
            selected: target
        })
    }

    const handleAddAcademicTitle = async(e) => {
        e.preventDefault()
 
        if(newAcademicTitle?.selected?.value){
            dispatch(addCandidateTitle(newAcademicTitle.selected.value, formStateNewAcademic, candidateId || client?.id, titleFile, 'title'))
            setFormStateNewAcademic({
                studyCentre: '',
                end_date: '',
                certificationUrl: null
            })
            setTitleFile(null)
            setNewAcademicTitle({...newAcademicTitle, selected: null})
            titleFileInput.current.value = null
            window.scrollTo({
                top: 0,
                behavior: 'instant',
            })
        }else{
            Swal.fire({
                showConfirmButton: true,
                icon: 'error',
                text: t('profile.candidate.thereisnotworktype')
            })
        }
    }

    const handleAddAcademicPostTitle = async(e) => {
        e.preventDefault()

        dispatch(addCandidateTitle(formStateNewAcademicPostTitle.title, formStateNewAcademicPostTitle, candidateId || client?.id, postTitleFile, formStateNewAcademicPostTitle.type))
        setFormStateNewAcademicPostTitle({
            type: 'postgraduate',
            title: '',
            studyCentre: '',
            end_date: '',
            certificationUrl: null,
        })
        setPostTitleFile(null)
        postTitleFileInput.current.value = null
    }

    const handleDeleteAcademic = async(e, title) => {
        e.preventDefault()

        Swal.fire({
            showConfirmButton: true,
            showDenyButton: true,
            confirmButtonText: t('global.yes'),
            denyButtonText: t('global.no'),
            icon: 'question',
            text: t('profile.candidate.areyousuredelete')
        }).then((resultuser) => {
            if (resultuser.isConfirmed) {
                dispatch(deleteCandidateTitle(title, candidateId || client?.id))
            }
        })
    }

    const handleDeleteCandidateTeacherFormationMaster = async(e) => {
        e.preventDefault()

        Swal.fire({
            showConfirmButton: true,
            showDenyButton: true,
            confirmButtonText: t('global.yes'),
            denyButtonText: t('global.no'),
            icon: 'question',
            text: t('profile.candidate.areyousuredelete')
        }).then((resultuser) => {
            if (resultuser.isConfirmed) {
                dispatch(deleteCandidateTeacherFormationMaster(candidateId || client?.id))
            }
        })
    }

    const handleChangeSpecificFormation = async(e) => {
        e.preventDefault()
        if (candidate.teacherFormationMaster !== specificFormationForm.teacherFormationMaster || candidate.ibTeacher !== specificFormationForm.ibTeacher || candidate.deca !== specificFormationForm.deca || candidate.teacherFormationMasterCertificateUrl !== specificFormationForm.teacherFormationMasterCertificateUrl || candidate.ibTeacherCertificateUrl !== specificFormationForm.ibTeacherCertificateUrl) {
            dispatch(changeSpecificFormation(specificFormationForm, candidateId || client?.id))

            if (teacherFormationMasterCertificateInput.current){
                teacherFormationMasterCertificateInput.current.value = null
            }
            if (ibTeacherCertificateInput.current){
                ibTeacherCertificateInput.current.value = null
            }

            setSpecificFormationForm({
                ...specificFormationForm,
                teacherFormationMasterCertificateUrl: null,
                ibTeacherCertificateUrl: null
            })
        }
    }

    const changeTitleFile = (e) => {
		setTitleFile(e.target.files[0])
	}

    const changePostTitleFile = (e) => {
		setPostTitleFile(e.target.files[0])
	}

    useEffect(() => {
        if(resultcandidate){
            switch (resultcandidate) {
                case 'successaddacademic':
                    dispatch(getCandidate(candidateId || client?.id))
                    dispatch(getCandidateProfileStatus(candidateId || client?.id))
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('profile.candidate.successaddacademic')
                    })
                    break;
                case 'erroraddacademic':
                    Swal.fire({
                        showConfirmButton: true,
                        icon: 'warning',
                        text: t('profile.candidate.erroraddacademic')
                    })
                    break;
                case 'successdeleteacademic':
                    dispatch(getCandidate(candidateId || client?.id))
                    dispatch(getCandidateProfileStatus(candidateId || client?.id))
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('profile.candidate.successdeleteacademic')
                    })
                    break;
                case 'deleteTeacherFormationMasterSuccess':
                    dispatch(getCandidate(candidateId || client?.id))
                    dispatch(getCandidateProfileStatus(candidateId || client?.id))
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('profile.candidate.successdeleteacademic')
                    })
                    break;
                case 'successChangeSpecificFormation':
                    dispatch(getCandidate(candidateId || client?.id))
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('profile.candidate.successChangeSpecificFormation')
                    })
                    break;
                case 'errorChangeSpecificFormation':
                    Swal.fire({
                        showConfirmButton: true,
                        icon: 'warning',
                        text: t('profile.candidate.errorChangeSpecificFormation')
                    })
                    break;
                case 'successAddCourse':
                    dispatch(getCandidate(candidateId || client?.id))
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('profile.candidate.successAddCourse')
                    })
                    break;
                case 'errorAddCourse':
                    Swal.fire({
                        showConfirmButton: true,
                        icon: 'warning',
                        text: t('profile.candidate.errorAddCourse')
                    })
                    break;
                case 'successDeleteCourse':
                    dispatch(getCandidate(candidateId || client?.id))
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('profile.candidate.successDeleteCourse')
                    })
                    break;
                case 'errorDeleteCourse':
                    Swal.fire({
                        showConfirmButton: true,
                        icon: 'warning',
                        text: t('profile.candidate.errorDeleteCourse')
                    })
                    break;
                default:
                    break;
            }
        }
    // eslint-disable-next-line
    }, [resultcandidate])

    useEffect(() => {
        if(candidate){
            setSpecificFormationForm({
                ...specificFormationForm,
                teacherFormationMaster: candidate.teacherFormationMaster || false,
                ibTeacher: candidate.ibTeacher || false,
                deca: candidate.deca || false
            })
        }
    // eslint-disable-next-line
    }, [candidate])

    return (
        <>
            <Container className='cuerpo'>
                <Row className='mb-4'>
                    <Col className='d-flex align-items-center'>
                        <img src="/images/titulosbig.svg" alt="Icono Titulos" />
                        <h1 className='ms-2 m-0'>{t('menus.academic')}</h1>
                    </Col>
                </Row>
                <Row className="mt-2">
                    <Col>
                        <Card className='mb-5 sombra lateral' >
                            <Card.Body className='p-0 d-flex'>
                                <div className='d-none d-sm-block submenu-lateral'>
                                    <SubMenuTitles seccion='official' usertype={candidateId ? 'Superadmin' : 'Candidate'} candidateId={candidateId || client?.id} />
                                </div>
                                <div className='px-5 py-3 contenido-datos'>
                                    <Row className="mt-5 mb-3">
                                        <Col>
                                            <h3>{t('profile.candidate.officialTitles')}</h3>
                                        </Col>
                                    </Row>
                                    <Row>
                                        {candidate?.academic?.length > 0
                                            ?
                                                candidate?.academic?.map((title, key) => (
                                                    <Col xs={12} className='bloque-adjuntos d-flex justify-content-between align-items-center' key={key}>
                                                        <div className='d-flex'>
                                                            <div className='me-3'><img src="/images/diploma.svg" className='w-65px' alt="Diploma"/></div>
                                                            <div>
                                                                <h4 className='fw-bold'>
                                                                {title.type === 'title'
                                                                    ?
                                                                        t('titles.' +titles?.find(t => t.id === parseInt(title.title))?.title) || t('profile.candidate.' + title.type) + ' - ' + t('titles.' + title.title)
                                                                    :
                                                                        <>
                                                                            {t('profile.candidate.'+title.type)}: {title.title}
                                                                        </>
                                                                }

                                                                </h4>
                                                                {title.studyCentre} | {title.end_date ? title.end_date?.substr(5,2)+' - '+title.end_date?.substr(0,4) : t('profile.candidate.nodate')}
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <a href={title.certificationUrl} download target="_blank" rel="noreferrer">
                                                                <i className='fas fa-download'/>
                                                            </a>
                                                            <img src="/images/trash.svg" className='ms-2 cursor' alt="Trash" onClick={e => handleDeleteAcademic(e, title._id)} />
                                                        </div>
                                                    </Col>
                                                ))
                                            :
                                                <></>
                                        }
                                        {
                                            candidate?.teacherFormationMaster &&
                                                <Col xs={12} className='bloque-adjuntos d-flex justify-content-between align-items-center'>
                                                    <div className='d-flex'>
                                                        <div className='me-3'><img src="/images/diploma.svg" className='w-65px' alt="Diploma"/></div>
                                                        <div>
                                                            <h4 className='fw-bold'>{t('profile.candidate.teacherFormationMaster')}</h4>
                                                            {candidate.teacherFormationMaster.studyCentre} | {candidate.teacherFormationMaster.end_date ? candidate.teacherFormationMaster.end_date?.substr(5,2) + ' - ' + candidate.teacherFormationMaster.end_date?.substr(0,4) : t('profile.candidate.nodate')}
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <a href={candidate.teacherFormationMaster.certificationUrl} download target="_blank" rel="noreferrer">
                                                            <i className='fas fa-download'/>
                                                        </a>
                                                        <img src="/images/trash.svg" className='ms-2 cursor' alt="Trash" onClick={e => handleDeleteCandidateTeacherFormationMaster(e)} />
                                                    </div>
                                                </Col>
                                        }
                                    </Row>
                                    <Row className="mt-1 mb-3">
                                        <Col className="justify-content-center">
                                            <Form onSubmit={handleAddAcademicTitle}>
                                                <Row className='mt-4 mb-0'>
                                                    <Col>
                                                        <h4>{t('profile.candidate.titles')}</h4>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col xs={12} lg={6} className="my-3">
                                                        <Form.Label>{t('profile.candidate.title')}</Form.Label>
                                                        <Select
                                                            className="select"
                                                            onChange={handleSelectNewAcademic}
                                                            name="title_type"
                                                            options={newAcademicTitle.options}
                                                            value={newAcademicTitle.selected}
                                                            required
                                                        />
                                                    </Col>
                                                    <Col xs={12} lg={6} className="my-3">
                                                        <Form.Label>{t('profile.candidate.studyCentre')}</Form.Label>
                                                        <Form.Control
                                                            type='text'
                                                            name='studyCentre' 
                                                            value={formStateNewAcademic.studyCentre ||  ''}
                                                            onChange={handleInputNewAcademic}
                                                            required
                                                        />
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col xs={12} lg={6} className="my-3">
                                                        <Form.Label>{t('profile.candidate.end_date')}</Form.Label>
                                                        <Form.Control
                                                            type="month"
                                                            name="end_date"
                                                            value={formStateNewAcademic.end_date ||  ''}
                                                            placeholder={t('profile.candidate.end_date')}
                                                            onChange={handleInputNewAcademic}
                                                        />
                                                    </Col>
                                                    <Col xs={12} lg={6} className="my-3">
                                                        <Form.Label>{t('profile.candidate.uploadCertification')}</Form.Label>
                                                        <Form.Control type='file' required name='certificationUrl' onChange={changeTitleFile} ref={titleFileInput} />
                                                        {
                                                            titleFile &&
                                                                <span className='text-muted'>{titleFile.name}</span>
                                                        }
                                                    </Col>
                                                </Row>
                                                <Row className="my-3 d-flex justify-content-end">
                                                    <Col xs='12' lg='6'>
                                                        <Button type="submit" className="btn-primary w-100 my-2">{t('profile.candidate.addNewAcademic')}</Button>
                                                    </Col>
                                                </Row>
                                            </Form>
                                        </Col>
                                    </Row>
                                    <Row className="mt-1 mb-3">
                                        <Col className="justify-content-center">
                                            <Form onSubmit={handleAddAcademicPostTitle}>
                                                <Row className='mt-4 mb-0'>
                                                    <Col>
                                                        <h4>{t('profile.candidate.postTitles')}</h4>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col xs={12} lg={6} className="my-3">
                                                        <Form.Label>{t('profile.candidate.type')}</Form.Label>
                                                        <FormSelect name='type' className='form-control' onChange={handleInputNewAcademicPostTitle} value={formStateNewAcademicPostTitle.type}>
                                                            <option value='postgraduate'>{t('profile.candidate.postgraduate')}</option>
                                                            <option value='master'>{t('profile.candidate.master')}</option>
                                                            {
                                                                !candidate?.teacherFormationMaster &&
                                                                    <option value='teacherFormationMaster'>{t('profile.candidate.teacherFormationMaster')}</option>
                                                            }
                                                        </FormSelect>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col xs={12} lg={6} className="my-3">
                                                        <Form.Label>{t('profile.candidate.title')}</Form.Label>
                                                        <Form.Control
                                                            type='text'
                                                            name='title'
                                                            value={formStateNewAcademicPostTitle.type === 'teacherFormationMaster' ? t('profile.candidate.teacherFormationMaster') : formStateNewAcademicPostTitle.title ||  ''}
                                                            onChange={handleInputNewAcademicPostTitle}
                                                            disabled={formStateNewAcademicPostTitle.type === 'teacherFormationMaster'}
                                                            required
                                                        />
                                                    </Col>
                                                    <Col xs={12} lg={6} className="my-3">
                                                        <Form.Label>{t('profile.candidate.studyCentre')}</Form.Label>
                                                        <Form.Control
                                                            type='text'
                                                            name='studyCentre' 
                                                            value={formStateNewAcademicPostTitle.studyCentre ||  ''}
                                                            onChange={handleInputNewAcademicPostTitle}
                                                            required
                                                        />
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col xs={12} lg={6} className="my-3">
                                                        <Form.Label>{t('profile.candidate.end_date')}</Form.Label>
                                                        <Form.Control
                                                            type="month"
                                                            name="end_date"
                                                            value={formStateNewAcademicPostTitle.end_date ||  ''}
                                                            placeholder={t('profile.candidate.end_date')}
                                                            onChange={handleInputNewAcademicPostTitle}
                                                        />
                                                    </Col>
                                                    <Col xs={12} lg={6} className="my-3">
                                                        <Form.Label>{t('profile.candidate.uploadCertification')}</Form.Label>
                                                        <Form.Control type='file' required name='certificationUrl' onChange={changePostTitleFile} ref={postTitleFileInput} />
                                                        {
                                                            postTitleFile &&
                                                                <span className='text-muted'>{postTitleFile.name}</span>
                                                        }
                                                    </Col>
                                                </Row>
                                                <Row className="my-3 d-flex justify-content-end">
                                                    <Col xs='12' lg='6'>
                                                        <Button type="submit" className="btn-primary w-100 my-2">{t('profile.candidate.addNewAcademicPostTitle')}</Button>
                                                    </Col>
                                                </Row>
                                            </Form>
                                        </Col>
                                    </Row>
                                    <Row className='mt-5 mb-2'>
                                        <Col xs={12}>
                                            <h3>{t('profile.candidate.specificFormation')}</h3>
                                        </Col>
                                    </Row>
                                    <Form onSubmit={handleChangeSpecificFormation}>
                                        <Row className="py-3 borde-inferior">
                                            <Col xs={12} lg={8}>
                                                <Form.Label htmlFor='ibTeacher' className='m-0 me-5'>{t('profile.candidate.ibTeacherLabel')}</Form.Label>
                                                <div className='d-flex'>
                                                    <Form.Check
                                                        className="mx-2"
                                                        type="switch"
                                                        name="ibTeacher"
                                                        id="ibTeacher"
                                                        onChange={e => {setSpecificFormationForm({...specificFormationForm, "ibTeacher": e.target.checked})}}
                                                        checked={specificFormationForm.ibTeacher}
                                                    />
                                                    {specificFormationForm.ibTeacher ? t('global.yes') : t('global.no')}
                                                </div>
                                            </Col>                                            
                                            {
                                                specificFormationForm.ibTeacher &&
                                                    <Col xs={12} lg={4}>
                                                        <Form.Label>{t('profile.candidate.uploadIbTeacher')}</Form.Label>
                                                        <Form.Control type='file' size='sm' required={specificFormationForm.ibTeacher && !candidate?.ibTeacherCertificateUrl} name='ibTeacherUrl' onChange={(e) => setSpecificFormationForm({...specificFormationForm, ibTeacherCertificateUrl: e.target.files[0]})} ref={ibTeacherCertificateInput} />
                                                        {
                                                            specificFormationForm.ibTeacherCertificateUrl &&
                                                                <span className='text-muted'>{specificFormationForm.ibTeacherCertificateUrl.name}</span>
                                                        }
                                                    </Col>
                                            }
                                            {
                                                candidate?.ibTeacherCertificateUrl &&
                                                    <Col xs={12} className='bloque-adjuntos'>
                                                        <a href={candidate?.ibTeacherCertificateUrl} download target='_blank' rel='noreferrer'>
                                                            <i className='fas fa-download fa-3x me-3'/> <FileNameExtractor documentimage={candidate?.ibTeacherCertificateUrl}/>
                                                        </a>
                                                    </Col>
                                            }
                                        </Row>
                                        <Row className="py-3 borde-inferior">
                                            <Col xs={12} lg={8}>
                                                <Form.Label htmlFor='deca' className='m-0 me-5'>{t('profile.candidate.decaLabel')}</Form.Label>
                                                <div className='d-flex'>
                                                    <Form.Check
                                                        className="mx-2"
                                                        type="switch"
                                                        name="deca"
                                                        id="deca"
                                                        onChange={e => {setSpecificFormationForm({...specificFormationForm, "deca": e.target.checked})}}
                                                        checked={specificFormationForm.deca}
                                                    />
                                                    {specificFormationForm.deca ? t('global.yes') : t('global.no')}
                                                </div>                                                
                                            </Col>
                                        </Row>
                                        <Row className="my-3 d-flex justify-content-end">
                                            <Col xs='12' lg='6'>
                                                <Button type="submit" className="btn-primary w-100 my-2">{t('global.save')}</Button>
                                            </Col>
                                        </Row>
                                    </Form>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    )
}